import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MeetingSummaryResult, MeetingSummaryKeyMessage, MeetingSummaryFollowUpItem } from '../../../../models/nova-voice.model';

export interface ApplySelections {
  keyMessages: MeetingSummaryKeyMessage[];
  followUpItems: MeetingSummaryFollowUpItem[];
}

@Component({
  selector: 'nova-call-analysis',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  templateUrl: './call-analysis.component.html',
  styleUrls: ['./call-analysis.component.scss'],
})
export class NovaCallAnalysisComponent implements OnInit {
  @Input() data: MeetingSummaryResult;
  @Input() isProcessing: boolean = false;
  @Output() applySelections = new EventEmitter<ApplySelections>();

  ngOnInit() {
    if (this.data?.key_messages) {
      this.data.key_messages.forEach(km => km.accepted = true);
    }
  }

  get hasAcceptedMessages(): boolean {
    return (this.data?.key_messages ?? []).some(k => k.accepted);
  }

  toggleKeyMessage(km: MeetingSummaryKeyMessage) {
    km.accepted = !km.accepted;
  }

  getSentimentColor(): string {
    switch (this.data?.sentiment_analysis?.overall_sentiment) {
      case 'positive': return 'var(--nova-accent)';
      case 'negative': return 'var(--nova-danger)';
      default: return 'var(--nova-warning)';
    }
  }

  getSentimentRingStyle(): string {
    const raw = (this.data?.sentiment_analysis?.confidence ?? 0) * 100;
    const confidence = Math.min(100, Math.max(0, raw));
    const color = this.getSentimentColor();
    return `conic-gradient(${color} ${confidence}%, var(--nova-border) ${confidence}%)`;
  }

  getPriorityClass(priority: string): string {
    switch (priority) {
      case 'high': return 'priority-badge high';
      case 'medium': return 'priority-badge medium';
      default: return 'priority-badge low';
    }
  }

  getConfidencePct(confidence: number): number {
    return Math.min(100, Math.max(0, (confidence ?? 0) * 100));
  }

  onApply() {
    if (!this.hasAcceptedMessages) return;
    const accepted = {
      keyMessages: (this.data.key_messages ?? []).filter(km => km.accepted),
      followUpItems: this.data.follow_up_items || [],
    };
    this.applySelections.emit(accepted);
  }
}
